export enum Variant {
  outlined = 'outlined',
  solid = 'solid',
  plain = 'plain',
}

export enum Size {
  medium = 'medium',
  large = 'large',
  small = 'small',
}
